import React from 'react';
import "./DualBarDesktop.scss";
import {Col, Row} from "antd";
import {LazyImage} from "../../../Components";

const style = {
    background: '#0092ff'
};

function DualBarDesktop ({item,LinkDispatcher}){
    return(
        <Row gutter={[16,4]} justify="center"  className="component-row">
        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24}} >
            <div className="block-pool" style={{order: 2}}>

                <div className="block-item-horizontal">
                    <div className="wrapper pointer"
                         onClick={() => LinkDispatcher(item.items[0].link_to, item.items[0])}>
                        {item.items[0] ?
                            <>
                                {/*<img src={item.items[0].image} alt=""/>*/}
                                <LazyImage type={'side'} src={item.items[0].image_desktop}/>
                                <span className="block-title">{item.items[0].title}</span>
                            </>
                            : null}
                    </div>

                    <div className="wrapper pointer"
                         onClick={() => LinkDispatcher(item.items[1].link_to, item.items[1])}>
                        {item.items[1] ?
                            <>
                                {/*<img src={item.items[1].image} alt=""/>*/}
                                <LazyImage type={'side'} src={item.items[1].image_desktop}/>
                                <span className="block-title">{item.items[1].title}</span>
                            </>
                            : null}
                    </div>
                </div>
            </div>
        </Col>
        </Row>
    )
}

export default DualBarDesktop;
